import { useContext, useEffect, useState } from "react";
import { useRouter } from "next/router";
import Image from 'next/image';
import Breadcrumbs from "../BreadCrumb";
import { CategoryItem, ProductListResponse } from "@/lib/constants";
import axios from "axios";
import { useUserStore } from "@/stores/useUserStore";
import { useCategoriesStore } from "@/stores/useCategoriesStore";
import { CustomVariantItemProps, MinProductItemProps, ProductVariantItemProps } from "../Product/constants";
import MinProduct from '../Product/MinProduct';
import { useInView } from 'react-intersection-observer';
import AddToCart from "../Product/AddToCart";
import { GlobalContext, GlobalState } from "@/context/useGlobalContext";
import BlurMinProduct from '../Product/BlurMinProduct';
import OrderBy from "./OrderBy";
import OrderByDialog from "./OrderByDialog";
import Cookies from "js-cookie";
import CryptoJS from 'crypto-js';


let category_slug: string[] = [];
let category_id: string[] = [];
let desktop_image_banner: string | null = null;
let mobile_image_banner: string | null = null;
let category_name: string | null = null;

export const sortList = [
  { name: "Popular", value: "popular" },
  { name: "New Arrival", value: "new_arrival" },
  // { name: "Best Seller", value: "best_seller" },
  { name: "Price: Low to High", value: "price" },
  { name: "Price: High to Low", value: "reverse_price" },
]

const Category = () => {
  const router = useRouter();
  const { showCart, setShowCart } = useContext(GlobalContext) as GlobalState;
  const { categories, getCategories } = useCategoriesStore();
  const { userInfo, getUser } = useUserStore();
  const [ productList, setProductList ] = useState<MinProductItemProps[]>([]);
  const [ query, setQuery ] = useState(true);
  const [ page, setPage ] = useState(1);
  const [ productCount, setProductCount ] = useState(-1);
  const [ isLoading, setIsLoading ] = useState(false);
  const [ orderBy, setOrderBy ] = useState<string>('popular');
  const [userData, setUserData] = useState(getUser());
  const [categoriesData, setCategoriesData] = useState(getCategories());
  const [customName, setCustomName] = useState<string | null>(null);
  const [selectProduct, setSelectProduct] = useState<MinProductItemProps | null>(null);
  const [variant, setVariant] = useState<ProductVariantItemProps | null>(null);
  const [selectedCustomVariant, setSelectedCustomVariant] = useState<CustomVariantItemProps | null>(null);
  const [fromName, setFromName] = useState<string>('');
  const [toName, setToName] = useState<string>('');
  const [toEmail, setToEmail] = useState<string>('');
  const [toMobile, setToMobile] = useState<string>('');
  const [toMessage, setToMessage] = useState<string>('');
  const [pregnancy, setPregnancy] = useState<string>('');
  const [duDate, setDuDate] = useState<Date | null>(null);
  const [childName, setChildName] = useState<string>('');
  const [childAge, setChildAge] = useState<number | null>(null);
  const [childGender, setChildGender] = useState<string>('');
  const [open, setOpen] = useState(false);
  const [forceFetch, setForceFetch] = useState(false);
  const [affiliate, setAffiliate] = useState<string | undefined>(undefined);
  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0,
  });

  const get_category_id = async (p_category: CategoryItem[], category_id: string[]) => {
    for (let i = 0; i < p_category.length; i++) {
      if (!category_id.includes(p_category[i].id.toString())) {
        category_id.push(p_category[i].id.toString());

        if (desktop_image_banner === null && p_category[i].desktop_image_banner !== null) {
          desktop_image_banner = p_category[i].desktop_image_banner;
          category_name = p_category[i].name;
        }

        if (mobile_image_banner === null && p_category[i].mobile_image_banner !== null) {
          mobile_image_banner = p_category[i].mobile_image_banner;
          category_name = p_category[i].name;
        }
      }

      get_category_id(p_category[i].subcategory, category_id);
    }
  }

  const fetch_category_slug = async (
    path: string | string[] | undefined,
    categories: CategoryItem[] | null,
    category_id: string[],
    category_slug: string[]
  ) => {
    let category_list = categories;

    if (path !== undefined && categories !== null) {
      if (Array.isArray(path)) {
        if (path.length === 2 && path[0] === "all-category" && path[1].length > 0) {
          category_slug.push(path[1]);
        } else {
          for (let i = 0; i < path.length; i++) {
            let cc: CategoryItem[] = []

            if (category_list != null) {
              cc = category_list.filter((category) => category.slug === path[i]);
            } else {
              cc = categories.filter((category) => category.slug === path[i]);
            }

            if (cc.length > 0) {
              if (i < path.length - 1) {
                category_list = cc[0].subcategory;
              } else {
                await get_category_id(cc, category_id);
              }
            }
          }
        }
      } else if (category_list != null) {
        let cc = category_list.filter((category) => category.slug === path);

        if (cc.length > 0) {
          await get_category_id(cc, category_id);
        }
      }
    }
  }

  const handleRouteChange = () => {
    setQuery(true);
    setProductList([]);
    setPage(1);
    setOrderBy('popular');
    setForceFetch(true);
    category_slug = [];
    category_id = [];
    mobile_image_banner = null;
    desktop_image_banner = null;

    sessionStorage.setItem('isRefreshed', 'false');
    setAffiliate(Cookies.get(window.btoa("affiliate")));
  }

  useEffect(() => {
    router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    };
  }, [router.events]);

  useEffect(() => {
    const checkIsRefreshed = async () => {
      try {
        const isRefreshed = sessionStorage.getItem('isRefreshed');

        if (isRefreshed) {
            handleRouteChange();
        }
      } catch (error: any) {
        try {
          const body = {data: {path: router.asPath, type: "get is refreshed from session storage", error: error}, timestamp: new Date().getTime()};
          await axios.post(
            "/api/report",
            {data: CryptoJS.AES.encrypt(JSON.stringify(body), process.env.NEXT_PUBLIC_KEY || '').toString()}
          )
        } catch (error) {
          console.log(error);
        }
      }
    };

    checkIsRefreshed();

    const handleBeforeUnload = () => {
      sessionStorage.setItem('isRefreshed', 'true');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    setQuery(true);
    setProductList([]);
    setPage(1);
    setForceFetch(true);
    category_slug = [];
    category_id = [];
    mobile_image_banner = null;
    desktop_image_banner = null;
  }, [orderBy])

  useEffect(() => {
    setUserData(getUser());
  }, [getUser, userInfo])

  useEffect(() => {
    setCategoriesData(getCategories());
  }, [getCategories, categories])

  if (category_slug.length === 0 && category_id.length === 0) {
    fetch_category_slug(router.query.slug, categoriesData.data, category_id, category_slug);
  }

  const fetchProductList = async () => {
    let index = [(page - 1) * 20, page * 20].toString();

    if (router.query.package !== undefined) {
      category_slug = ['all-promo'];
    } else if (router.query.brand !== undefined) {
      category_slug = ['brand'];
      category_id = [];
    } else if (router.query.keyword !== undefined) {
      category_slug = ['all-category'];
    } else if (category_slug.length === 0 && router.query.slug !== undefined && Array<string> === router.query.slug.constructor) {
      category_slug = router.query.slug;
    }

    const params = {
      category_id: category_id.toString(),
      category_slug: category_slug.toString(),
      order_by: orderBy,
      index: index,
      package: router.query.package,
      brand: router.query.brand,
      keyword: router.query.keyword,
      category: router.query.category,
      flash_sale: router.query.flash_sale,
    }

    try {
      const response = await axios.get<ProductListResponse>(
        process.env.NEXT_PUBLIC_API_URL! + process.env.NEXT_PUBLIC_API_PRODUCT_LIST!,
        {
          headers: { 'Authorization': 'Bear ' + userData.token },
          params: params
        }
      )

      setProductCount(response.data.total_count);
      setProductList(productList.concat(response.data.product_list));
      setCustomName(response.data.display_name);

      if (category_id.length === 0 && response.data.display_name.length === 0) {
        setCustomName(category_slug[0].startsWith('rekomendasi-produk-custom-') ? category_slug[0].replace('rekomendasi-produk-custom-', '').replace(/-/g, ' ') : category_slug[0].replace(/-/g, ' '));
      }

      setPage(page + 1);

      if (response.data.total_count / 20 <= page) {
        setQuery(false);
      }

      setIsLoading(false);
    } catch (error: any) {
      try {
        const body = {data: {error: error?.response?.data || error, params: params, path: router.asPath, type: "get product list"}, timestamp: new Date().getTime()};
        await axios.post(
          "/api/report",
          {data: CryptoJS.AES.encrypt(JSON.stringify(body), process.env.NEXT_PUBLIC_KEY || '').toString()}
        )
      } catch (error) {
        console.log(error);
      }
    }
  }

  if (query && (inView || forceFetch) && !isLoading && (category_id.length > 0 || category_slug.length > 0 || router.query.package !== undefined || (category_id.length === 0 && category_slug.length === 0))) {
    setIsLoading(true);
    setForceFetch(false);
    fetchProductList();
  }

  useEffect(() => {
    if (selectProduct !== null && !open) {
      if (userData.membershiplevel === "none" || userData.membershiplevel === "" || userData.user_id === undefined) {
        router.push('/login?redirect=' + router.asPath);
      } else {
        setVariant(selectProduct.product_variant_list[0]);
        setOpen(true);
      }
    }
  }, [selectProduct, open, userData.membershiplevel, userData.user_id, router])

  useEffect(() => {
    if (!open) {
      setSelectProduct(null);
      setVariant(null);
    }
  }, [open])

  return (
    <>
      <Breadcrumbs customName={customName} />
      {/* {mobile_image_banner !== null && mobile_image_banner !== undefined && mobile_image_banner.length > 0 && (
        <div className="w-full md:hidden">
          <Image
            src={mobile_image_banner}
            alt={category_slug + " banner"}
            width={0}
            height={0}
            sizes="100vw"
            className="w-full h-auto"
          />
        </div>
      )}
      {desktop_image_banner !== null && desktop_image_banner !== undefined && desktop_image_banner.length > 0 && (
        <div className="container hidden w-full md:block">
          <Image
            src={desktop_image_banner}
            alt={category_slug + " banner"}
            width={0}
            height={0}
            sizes="100vw"
            className="w-full h-auto"
          />
        </div>
      )} */}
      <div className="container my-6 md:mb-20">
        <div className="flex justify-between items-center">
          <div className={`${isLoading ? "hidden" : "block"} md:hidden`}>
            <OrderByDialog orderBy={orderBy} setOrderBy={setOrderBy} />
          </div>
          <div className={`hidden ${isLoading ? "md:hidden" : "md:block"}`}>
            <OrderBy orderBy={orderBy} setOrderBy={setOrderBy} />
          </div>
          {productCount !== -1 ? (
            <p className="text-xs text-black font-poppins">{productCount + " Products"}</p>
          ) : (
            <p></p>
          )}
        </div>
        <hr className="my-6 md:my-8 bg-reviewBg" />
        <div className="grid grid-cols-2 gap-x-4 gap-y-8 md:grid-cols-4 lg:grid-cols-5">
          {productList.length === 0 ? (
            Array.from({ length: 10 }, (_, index) => (
              <BlurMinProduct key={index} />
            ))
          ) : (
            productList.sort((a, b) => {
              if (a.qty === 0 && b.qty === 0) {
                return 0;
              } else if (a.qty === 0) {
                return 1;
              } else if (b.qty === 0) {
                return -1;
              } else {
                return 0;
              }
            }).map((product, index) => (
              <MinProduct
                key={index}
                attribute_value_list={product.attribute_value_list}
                brand={product.brand}
                cash_back={product.cash_back}
                id={product.id}
                cart_image={product.cart_image}
                image={product.image}
                name={product.name}
                product_discount_percent={product.product_discount_percent}
                product_label_bottom_left_category_page={product.product_label_bottom_left_category_page}
                product_label_bottom_right_category_page={product.product_label_bottom_right_category_page}
                product_label_left_product_page={product.product_label_left_product_page}
                product_label_right_product_page={product.product_label_right_product_page}
                msrp={product.msrp}
                qty={product.qty}
                sales_price={product.sales_price}
                sku={product.sku}
                slug={product.slug}
                special_price={product.special_price}
                type={product.type}
                url={product.url}
                product_variant_list={product.product_variant_list}
                attrId={null}
                customName={null}
                setSelectProduct={setSelectProduct}
                virtual_product={product.virtual_product}
                need_shipping={product.need_shipping}
                custom_variant_list={product.custom_variant_list}
                selectedCustomVariant={selectedCustomVariant}
                setSelectedCustomVariant={setSelectedCustomVariant}
                fromName={fromName}
                setFromName={setFromName}
                toName={toName}
                setToName={setToName}
                toEmail={toEmail}
                setToEmail={setToEmail}
                toMobile={toMobile}
                setToMobile={setToMobile}
                toMessage={toMessage}
                setToMessage={setToMessage}
                pregnancy={pregnancy}
                setPregnancy={setPregnancy}
                duDate={duDate}
                setDuDate={setDuDate}
                childName={childName}
                setChildName={setChildName}
                childAge={childAge}
                setChildAge={setChildAge}
                childGender={childGender}
                setChildGender={setChildGender}
                pwp_name={product.pwp_name}
                pwp={product.pwp}
              />
            ))
          )}
        </div>
        <div ref={ref}></div>
      </div>
      {selectProduct !== null && (
        <AddToCart
          id={selectProduct.id}
          name={selectProduct.name}
          msrp={selectProduct.msrp}
          sales_price={selectProduct.sales_price}
          product_code={selectProduct.sku}
          qty={selectProduct.qty}
          image={selectProduct.image}
          attribute_value_list={selectProduct.attribute_value_list}
          product_variant_list={selectProduct.product_variant_list}
          special_price={selectProduct.special_price}
          brand={selectProduct.brand}
          slug={selectProduct.slug}
          style="popup"
          variant={selectProduct.product_variant_list[0]}
          setVariant={setVariant}
          setShowCart={setShowCart}
          action="add"
          open={open}
          setOpen={setOpen}
          virtual_product={selectProduct.virtual_product}
          need_shipping={selectProduct.need_shipping}
          custom_variant_list={selectProduct.custom_variant_list}
          selectedCustomVariant={selectedCustomVariant}
          setSelectedCustomVariant={setSelectedCustomVariant}
          fromName={fromName}
          setFromName={setFromName}
          toName={toName}
          setToName={setToName}
          toEmail={toEmail}
          setToEmail={setToEmail}
          toMobile={toMobile}
          setToMobile={setToMobile}
          toMessage={toMessage}
          setToMessage={setToMessage}
          pregnancy={pregnancy}
          setPregnancy={setPregnancy}
          duDate={duDate}
          setDuDate={setDuDate}
          childName={childName}
          setChildName={setChildName}
          childAge={childAge}
          setChildAge={setChildAge}
          childGender={childGender}
          setChildGender={setChildGender}
          pwp_name={selectProduct.pwp_name}
          pwp={selectProduct.pwp}
          shared_sales_price={null}
          type={affiliate !== null && affiliate !== undefined ? "affiliate" : "ec"}
        />
      )}
    </>
  )
}

export default Category
